import { useMemo } from 'react';

import { loadPresets } from 'components/Presets/sources/presets';

import { useQuery } from '@gogame/query';

import { grid } from './queryKeyFactory';
import { useIsOwn } from './useIsOwn';

export const useLoadPresets = ({ enabled, presetKey, ...params }) => {
  const isOwn = useIsOwn();

  const query = useQuery(
    grid({ presetKey }),
    (_, { signal }) => {
      return loadPresets({ presetKey, ...params }, { signal });
    },
    {
      enabled,
    }
  );

  const dataWithOwn = useMemo(() => {
    return query.data?.reduce(
      (prev, cur) => {
        const preset = {
          ...cur,
          isOwn: isOwn(cur.user),
        };
        if (preset.isOwn) {
          prev.my.push(preset);
        } else {
          prev.public.push(preset);
        }
        return prev;
      },
      { my: [], public: [] }
    );
  }, [isOwn, query.data]);

  return {
    ...query,
    data: dataWithOwn,
  };
};
